/* Shared by the redesign's charts. */

/** The validated chart colours, always in this order: olive, plum, rust, blue, then grey for "Other". */
export const VIZ = ['var(--viz-1)', 'var(--viz-2)', 'var(--viz-3)', 'var(--viz-4)', 'var(--viz-other)']

/** A rounded-up axis maximum: 1, 2, 2.5 or 5 times a power of ten. */
export function niceMax(v: number) {
  if (v <= 0) return 1
  const p = Math.pow(10, Math.floor(Math.log10(v)))
  const f = v / p
  return (f <= 1 ? 1 : f <= 2 ? 2 : f <= 2.5 ? 2.5 : f <= 5 ? 5 : 10) * p
}

/** One hue, light to dark, for heat maps and cohorts. */
export const sequential = (f: number) =>
  `color-mix(in srgb, var(--viz-1) ${Math.round(8 + Math.max(0, Math.min(1, f)) * 82)}%, var(--surface))`
export const sequentialInk = (f: number) => (f > 0.55 ? '#fff' : 'var(--ink)')
